import {Component, signal, viewChildren} from '@angular/core';
import {OngletGestionEquipeComponent} from 'src/app/gestion-equipe/onglets-gestion-equipe/onglet-gestion-equipe.component';

@Component({
	selector: 'app-gestion-equipe',
	templateUrl: './gestion-equipe.component.html',
	styleUrl: './gestion-equipe.component.scss'
})
export class GestionEquipeComponent {
	activeTabIndex = signal(0);

	onglets = viewChildren<OngletGestionEquipeComponent>('ongletGestionEquipe');

	onChangeOnglet(index: number): void {
		this.activeTabIndex.set(index);
		this.onglets()[index]?.chargerDonnees();
	}
}
